import { Content } from 'antd/lib/layout/layout'
import { Outlet } from 'react-router-dom'

export default function Body() {
  return (
    <Content>
      <Outlet />
    </Content>
  )
}
